import * as React from 'react';

import * as styles from './TransportDepartmentIcon.css';

export const TransportDepartmentIcon: React.FC = () => <div className={styles['icon']} />;
